// DesignTabs.js
import React from "react";
import { Card } from "react-bootstrap";

const designNotes = [
  "The PNG file you save must not be wider than 22,4 inches.",
  "There is no limit to the length, it can be as long as you want.",
];

const designData = [
  {
    product: "ADULT UNISEX SHIRT VE SWEATSHIRT",
    sizes: ["XSMALL", "SMALL", "MEDIUM", "LARGE", "XLARGE", "2XL", "3XL"],
    front: {
      width: [10, 10.5, 11, 11.5, 12, 12.5, 13],
      height: [12, 13, 13.5, 14, 14.5, 15, 15.5],
    },
    pocket: {
      width: [3.5, 3.5, 4, 4, 4.2, 4.5, 4.5],
      height: [5, 5, 5, 5, 5, 5.5, 6],
    },
    back: {
      width: [10.5, 11, 11.5, 12, 12.5, 13, 13.5],
      height: [13, 14, 14.5, 15, 15.5, 16, 16.5],
    },
  },
  {
    product: "HOODIE",
    sizes: ["SMALL", "MEDIUM", "LARGE", "XLARGE", "2XL", "3XL"],
    front: {
      width: [10.5, 11, 11.5, 12, 12.5, 13],
      height: [9, 9.5, 10, 10.5, 11, 11.5],
    },
    back: {
      width: [11, 11.5, 12, 12.5, 13, 13.5],
      height: [14, 14.5, 15, 15.5, 16, 16.5],
    },
    pocket: { width: [3, 3.5, 4, 4.5, 5, 5], height: [5, 5, 5, 5, 5, 5] },
  },
  {
    product: "SWEATSHIRT HOODIE KOL DİZAYNI",
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    sleeve: {
      width: [3.5, 4, 4.5, 5, 5, 5],
      height: [9.5, 10, 10.5, 11, 11.5, 12],
    },
  },
  {
    product: "YOUTH SHIRT & SWEATSHIRT",
    sizes: ["SMALL", "MEDIUM", "LARGE", "XLARGE"],
    front: { width: [8, 8.5, 9, 9.5], height: [9.5, 10, 10.5, 11] },
    back: { width: [8.5, 9, 9.5, 10], height: [10, 10.5, 11, 11.5] },
    pocket: { width: [3, 3, 3, 3], height: [3, 3, 3, 3] },
  },
  {
    product: "TODDLER SHIRT",
    sizes: ["2T", "3T", "4T", "5T"],
    front: { width: [6.5, 7, 7.5, 8], height: [8, 8.5, 9, 9.5] },
    back: { width: [7, 7.5, 8, 8.5], height: [8.5, 9, 9.5, 10] },
    pocket: { width: [2.5, 2.5, 2.5, 2.5], height: [2.5, 2.5, 2.5, 2.5] },
  },
  {
    product: "BABY ONESIE",
    sizes: ["3M-6M", "6M-12M", "12M-18M", "18M-24M"],
    front: { width: [5, 5, 5.5, 5.5], height: [6, 6.5, 7, 7] },
    back: { width: [5.5, 5.5, 6, 6], height: [6.5, 7, 7.5, 7.5] },
    pocket: { width: [2, 2, 2, 2], height: [2, 2, 2, 2] },
  },
  {
    product: "RACERBACK & CROP",
    sizes: ["XSMALL", "SMALL", "MEDIUM", "LARGE", "XLARGE", "2XL"],
    front: {
      width: [8.5, 9, 9, 9.5, 9.5, 10],
      height: [11, 11.5, 12, 12.5, 13, 13],
    },
  },
  {
    product: "WOMAN SHIRT & V-NECK",
    sizes: ["SMALL", "MEDIUM", "LARGE", "XLARGE", "2XL", "3XL"],
    front: {
      width: [8, 9, 9.5, 10, 10.5, 11],
      height: [11, 11.5, 11.5, 12, 12.5, 13],
    },
  },
];

const pastelColors = [
  "#fef6e4",
  "#e3f6f5",
  "#fde2e4",
  "#e4c1f9",
  "#d0f4de",
  "#fcd5ce",
  "#caf0f8",
  "#fff1e6",
];

const DesignTabs = () => {
  const sections = ["front", "back", "pocket", "sleeve"];

  return (
    <div className="container">
      {designData.map((item, index) => (
        <Card
          key={index}
          className="mb-4 shadow-sm"
          style={{ backgroundColor: pastelColors[index % pastelColors.length] }}
        >
          <Card.Header className="fw-bold text-center bg-white border-bottom">
            {item.product}
          </Card.Header>
          <Card.Body>
            <div className="table-responsive">
              <table className="table table-bordered table-sm text-center align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Size</th>
                    {sections.map((section) =>
                      item[section] ? (
                        <>
                          <th key={section + "-w"}>
                            {section.toUpperCase()}
                            <br />
                            Max Width
                          </th>
                          <th key={section + "-h"}>
                            {section.toUpperCase()}
                            <br />
                            Max Height
                          </th>
                        </>
                      ) : null
                    )}
                  </tr>
                </thead>
                <tbody>
                  {item.sizes.map((size, i) => (
                    <tr key={i}>
                      <td className="fw-semibold bg-white">{size}</td>
                      {sections.map((section) =>
                        item[section] ? (
                          <>
                            <td key={`w-${section}-${i}`}>
                              {item[section].width[i]}
                            </td>
                            <td key={`h-${section}-${i}`}>
                              {item[section].height[i]}
                            </td>
                          </>
                        ) : null
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      ))}

      <Card className="mt-4 border-0" style={{ backgroundColor: "#f9f9f9" }}>
        <Card.Body>
          <ul
            style={{ fontSize: "13px", paddingLeft: "20px", marginBottom: 0 }}
          >
            {designNotes.map((note, i) => (
              <li key={i}>{note}</li>
            ))}
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
};

export default DesignTabs;
